import { Box, Flex, Heading, Progress } from "@chakra-ui/react";
import { useMemo } from "react";
import { QuizQuestion, QuizStep } from "../../services/guides/types";
import ShareButton from "../share-button";
import ViewStep from "./view-step";

interface Props {
  question: QuizQuestion;
  currentStep: QuizStep;
  onNextStep: () => void;
  onPrevStep: () => void;
  showShareButton?: boolean;
  voice?: SpeechSynthesisVoice;
}

export default function ViewQuestion(props: Props) {
  const totalSteps = props.question.steps.length;
  const stepIndex = props.question.steps.indexOf(props.currentStep);
  const pct = (stepIndex / totalSteps) * 100;

  const shareLink = useMemo(() => {
    const url = new URL(window.location.href);
    const userLanguage = url.searchParams.get("user-language");
    const practiceLanguage = url.searchParams.get("practice-language");
    url.search = "";

    if (userLanguage) {
      url.searchParams.set("user-language", userLanguage);
    }
    if (practiceLanguage) {
      url.searchParams.set("practice-language", practiceLanguage);
    }

    return url.toString();
  }, []);

  return (
    <Flex flexDir="column">
      <Progress value={pct} colorScheme="brand.blue" mb={5} />
      {props.showShareButton && (
        <Box position="relative">
          <Box top={1} right={1} position="absolute" zIndex={2}>
            <ShareButton
              color="rgba(255,255,255,0.3)"
              hoverColor="white"
              background="transparent"
              link={shareLink}
            />
          </Box>
        </Box>
      )}
      <ViewStep
        step={props.currentStep}
        voice={props.voice}
        onNextClick={props.onNextStep}
        onPrevClick={props.onPrevStep}
      />
    </Flex>
  );
}
